import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import DatatableExpand from "../../Constants/DatatableExpand";
import { Row, Col, Container, Label } from "reactstrap";
import { LOGOUT_ICON,PENCIL } from "../../Constants/SrcImages";
import {validateTokenStorage} from './../../Constants/Util';
import { COLUMNS_ASIGNATURE_PLANS, EXPAND_ROW_PLAN_MATERIA } from "../../Constants/DatatableColumns";
import { AdminModalAsignaturePlan} from "./../../Constants/Modal";
import {
  getPlans,
  getAllsignature,
  getAllAsignatureByPlan,
  deleteAsignatureByPlan,
  postAsignatureByPlan,
  putAsignatureByPlan
} from "../../Constants/Services";
import {IAsignatureByPlan} from './../../Constants/Interfaces';

 interface IPlans {
    pl_id: string;
    pl_desc: string;
}

interface IRegistrationState {
  dataPlans: IPlans[];
  dataPlanSelected: IPlans;
  dataAsignature: IAsignatureByPlan[];
  dataAsignatureByPlan: IAsignatureByPlan[];
  dataFormAsignatureByPlan: IAsignatureByPlan;
  isOpenModalAddAsignature: boolean;
  isOpenModalEditAsignature: boolean;
  msg_error: string;
  loading: boolean;
}

class SubjectByPlan extends Component<RouteComponentProps<{}>, IRegistrationState> {
  constructor(props: any) {
    super(props);
    this.state = {
        dataPlans: [],
        dataPlanSelected: {
        pl_id: "",
        pl_desc: ""
      },
      dataAsignature: [],
      dataAsignatureByPlan: [],
      dataFormAsignatureByPlan: {
        sp_id:"",
        as_id:"",
        as_desc:"",
        as_mother:"",
        as_plan:"",
        as_sub:"",
      },
      isOpenModalAddAsignature: false,
      isOpenModalEditAsignature:false,
      msg_error: "",
      loading: false
    };

    this.fetchPlan = this.fetchPlan.bind(this);
    this.fetchAsignatureByPlan = this.fetchAsignatureByPlan.bind(this);
    this.fetchAsignature = this.fetchAsignature.bind(this);
    this.handleModalAddAsignature = this.handleModalAddAsignature.bind(this);
    this.handleRechargeData = this.handleRechargeData.bind(this);
    this.handlerChangeAsignature = this.handlerChangeAsignature.bind(this);
    this.handleModalAddAsignature = this.handleModalAddAsignature.bind(this);
    this.handlerEdit = this.handlerEdit.bind(this);
    this.handleModalEditPlan = this.handleModalEditPlan.bind(this);
    this.handleModalEditAsignature = this.handleModalEditAsignature.bind(this);
    this.handleModalDeletePlan = this.handleModalDeletePlan.bind(this);
    this.handlerPostAsignature = this.handlerPostAsignature.bind(this);
  }

  async fetchPlan() {
    const response = await getPlans();
    this.setState({
      dataPlans: response,
      loading: false,
    });
  }

  async fetchAsignatureByPlan({pl_id,pl_desc}:IPlans) {
    const response = await getAllAsignatureByPlan(pl_id);
    this.setState({
      dataAsignatureByPlan: response,
      dataPlanSelected:{
          pl_id,
          pl_desc
      },
      loading: false,
    });
  }

  async fetchAsignature() {
    const response = await getAllsignature();
    this.setState({
      dataAsignature: response,
      loading: false,
    });
  }

  componentDidMount() {
    if(validateTokenStorage()){
      this.context.quitToken();
    }
    this.fetchPlan();
    this.fetchAsignature();
  }

  handlerPostAsignature() {
    const props = this.state.dataFormAsignatureByPlan;
    const propsPlans = this.state.dataPlanSelected;

    const body = {
      sp_plan: propsPlans.pl_id,
      sp_subject: props.as_id,
    };

    if(props.as_id.length>0 && propsPlans.pl_id.length>0){
      var xx = postAsignatureByPlan(body);
      xx.then((data) => {
        if(data.registrado){
          this.setState({ msg_error: "Esta materia ya se encuentra registrada en el plan" });
        }
        else{
          this.setState({ isOpenModalAddAsignature: false,msg_error: ""});
          setTimeout(() => {
            this.fetchAsignatureByPlan({pl_id:propsPlans.pl_id,pl_desc:propsPlans.pl_desc});
          }, 1000);
        }
      })
      .catch(function (e) {
        console.log(e);
      });
    }
    else{
      this.setState({msg_error:"Campos vacios"})
    }
  }

  handlerChangeAsignature() {
    const props = this.state.dataFormAsignatureByPlan;
    const propsPlans = this.state.dataPlanSelected;

    const body = {
      sp_id:props.sp_id,
      sp_plan: propsPlans.pl_id,
      sp_subject: props.as_id,
    };

    if(props.as_id.length>0 && propsPlans.pl_id.length>0){
      var xx = putAsignatureByPlan(body);
      xx.then((data) => {
        if(data.registrado){
          this.setState({ msg_error: "Esta materia ya se encuentra registrada en el plan" });
        }
        else{
          this.setState({ isOpenModalEditAsignature: false,msg_error: ""});
          setTimeout(() => {
            this.fetchAsignatureByPlan({pl_id:propsPlans.pl_id,pl_desc:propsPlans.pl_desc});
          }, 1000);
        }
      })
      .catch(function (e) {
        console.log(e);
      });
    }
    else{
      this.setState({msg_error:"Campos vacios"})
    }
  }

  handleModalAddAsignature() {
    this.setState((prevState) => ({
      isOpenModalAddAsignature: !prevState.isOpenModalAddAsignature,
      dataFormAsignatureByPlan:{
        sp_id:"",
        as_id:"",
        as_desc:"",
        as_mother:"",
        as_plan:"",
        as_sub:"",
      },
      msg_error:""
    }));
  }

  handleModalEditAsignature() {
    this.setState((prevState) => ({
      isOpenModalEditAsignature: !prevState.isOpenModalEditAsignature,
      dataFormAsignatureByPlan:{
        sp_id:"",
        as_id:"",
        as_desc:"",
        as_mother:"",
        as_plan:"",
        as_sub:"",
      },
      msg_error:""
    }));
  }

  setAsignatureSelected = ({as_id,as_desc}) => {
    this.setState({
        dataFormAsignatureByPlan: {
        ...this.state.dataFormAsignatureByPlan,
        as_id,
        as_desc,
      },
      msg_error:""
    });
  };

  handleRechargeData() {
    const propsPlan = this.state.dataPlanSelected;
    this.setState({ loading: true,msg_error:"" });
    setTimeout(() => {
      this.fetchAsignatureByPlan({pl_id:propsPlan.pl_id,pl_desc:propsPlan.pl_desc});
    }, 1000);
  }

  handleModalEditPlan(row: IAsignatureByPlan) {
    this.setState((prevState) => ({
      isOpenModalEditAsignature: !prevState.isOpenModalEditAsignature,
      dataFormAsignatureByPlan:{
        sp_id:row.sp_id,
        as_id:row.as_id,
        as_desc:row.as_desc,
        as_mother:row.as_mother,
        as_plan:"",
        as_sub:row.as_sub,
      },
      msg_error:""
    }));
  }

  handleModalDeletePlan(row: IAsignatureByPlan) {
    const propsPlans = this.state.dataPlanSelected;
    const body = {
      sp_id: row.sp_id,
    };


     deleteAsignatureByPlan(body);
     this.setState({ isOpenModalAddAsignature: false,loading:true });
     setTimeout(() => {
       this.fetchAsignatureByPlan({pl_id:propsPlans.pl_id,pl_desc:propsPlans.pl_desc});
     }, 1000);
  }

  handlerEdit = (cell: any, row: IAsignatureByPlan) => (
    <React.Fragment>
      <Row>
        <Col xs={12} className="d-flex">
          <Label className="txt-underline" onClick={() => this.handleModalEditPlan(row)}>
            {row.as_id}
          </Label>
          <img className="img-status img-search" onClick={() => this.handleModalEditPlan(row)} src={PENCIL} alt="" />
          <img className="img-status img-search" onClick={() => this.handleModalDeletePlan(row)} src={LOGOUT_ICON} alt="" />
        </Col>
      </Row>
    </React.Fragment>
  );

  render() {
    const props = this.state;
    return (
      <React.Fragment>
        {props.isOpenModalAddAsignature && (
          <AdminModalAsignaturePlan
          title="Agregar materia"
            msg_error={props.msg_error}
            materia={props.dataAsignature}
            dataFmateria={props.dataFormAsignatureByPlan}
            setMateria={this.setAsignatureSelected}
            isOpen={props.isOpenModalAddAsignature}
            toggle={this.handleModalAddAsignature}
            toggleSave={this.handlerPostAsignature}
          />
        )}
        {props.isOpenModalEditAsignature && (
          <AdminModalAsignaturePlan
          title="Editar materia"
            msg_error={props.msg_error}
            materia={props.dataAsignature}
            dataFmateria={props.dataFormAsignatureByPlan}
            setMateria={this.setAsignatureSelected}
            isOpen={props.isOpenModalEditAsignature}
            toggle={this.handleModalEditAsignature}
            toggleSave={this.handlerChangeAsignature}
          />
        )}
        <Container className="mt-4">
          <Row>
            <Col sm={12}>
              <Row className="body-margin">
                <Col sm={12} className="text-center">
                  <Label className="font-weight-bold">
                    <h3>Materias por plan</h3>
                    <br></br>
                   
                  </Label>
                </Col>
                <Col sm={12}>
                  <DatatableExpand
                    data={props.dataPlans}
                    columns={COLUMNS_ASIGNATURE_PLANS()}
                    keyProp="pl_id"
                    expandRow={EXPAND_ROW_PLAN_MATERIA(
                      props.loading,
                      this.handleRechargeData,
                      this.fetchAsignatureByPlan,
                      props.dataAsignatureByPlan,
                      this.handleModalAddAsignature,
                      this.handleModalAddAsignature,
                      this.handlerEdit
                    )}
                    exportD={false}
                    searchs={false}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default SubjectByPlan;
